const module = { name: 'theater/shared/theaterTicketingOptions', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { device: { isMobile }, theater } } = Fandango_context;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { Fandango_dropdown as dropdown } from 'base-libraries';



import { Fandango_overlay as fdOverlay } from 'base-libraries';



import { swig as swig } from 'require-core';



const Selectors = {
    MODAL: '#theater-ticketing-options',
    CONTAINER: '#theater-ticketing-options',
    OPTIONS_LIST: '#ticketing-options-list',
    SECTION: '#theater-details-header-ticketing-options',
    OPEN_BTN: '#theater-ticketing-info-open-btn',
}


const Styles = {
    CONTAINER: 'theater-ticketing-options__container',
    CONTAINER_DESKTOP: 'theater-ticketing-options__container--desktop',
    CLOSE_BTN: 'theater-ticketing-options__close-btn',
}


const DROPDOWN_NAME = 'theaterTicketingOptionsDesktop'


let abTestClickHandler
function launchTrack(platform) {
    track({
        event: EventTypes.MODAL,
        pageType: 'modal',
        platform,
        server: 'fandango responsive',
        modalName: 'theaters | ticketing options'
    });
}
function onClick(e) {
    if (abTestClickHandler) {
        return abTestClickHandler(this);
    }
    const isDesktop = !isMobile;
    const markup = swig.render('_theaterTicketingOptions', {
        theater,
        isDesktop
    });
    if (isDesktop) {
        dropdown.open(markup, {
            closeBtnParent: Selectors.CONTAINER,
            closeBtnStyle: Styles.CLOSE_BTN,
            dropdownStyle: Styles.CONTAINER_DESKTOP,
            name: DROPDOWN_NAME,
            openParent: e.currentTarget.id,
            relativeParent: Selectors.SECTION,
        });
        const list = document.querySelector(Selectors.OPTIONS_LIST);
        document.querySelector(Selectors.MODAL).style.left = list ? (`${list.scrollWidth + 28}px`) : '0';
        launchTrack('fandango web');
    }
    else {
        fdOverlay.open(markup, {
            closeBtnParent: Selectors.CONTAINER,
            closeBtnStyle: Styles.CLOSE_BTN,
            overlayStyle: Styles.CONTAINER,
            microModalOpts: {
                onClose(modal) {
                    modal.remove();
                }
            }
        });
        launchTrack('fandango mobile web');
    }
}
function init() {
    const btn = document.querySelector(Selectors.OPEN_BTN);
    if (!btn) {
        return;
    }
    btn.addEventListener('click', onClick);
}
module.exports = {
    init,
    replaceClickHandler(clickHandler) {
        abTestClickHandler = typeof clickHandler === 'function' ? clickHandler : null;
    }
};
export default module.exports;